import { Box, Layout, theme } from '@/components';
import type { ComponentProps, FC, PropsWithChildren, ReactNode } from 'react';
import { SiderHeader } from './SiderHeader';

type Size = 'sm' | 'lg';
const SiderSize: Record<Size, number> = { sm: 378, lg: 736 };

type Props = {
  open: boolean;
  size?: Size;
  headerRightContent?: ReactNode;
} & Omit<ComponentProps<typeof SiderHeader>, 'height' | 'extra'>;

export const CollapsibleSider: FC<PropsWithChildren<Props>> = ({
  open,
  canBack,
  onBack,
  children,
  size = 'sm',
  headerRightContent,
}) => {
  const { token } = theme.useToken();

  // This value is same as the Drawer width.
  const width = SiderSize[size];
  const headerHeight = 64;
  const borderStyle = `1px solid ${token.colorFill}`;

  return (
    <Layout.Sider
      theme="light"
      collapsed={!open}
      collapsedWidth="0"
      width={width}
      style={{
        position: 'sticky',
        zIndex: 20,
        borderLeft: open ? borderStyle : 'none',
      }}
    >
      <SiderHeader
        height={headerHeight}
        canBack={canBack}
        onBack={onBack}
        extra={headerRightContent}
      />
      <Box
        height={`calc(100vh - ${headerHeight}px)`}
        overflow="auto"
        padding={24}
      >
        {children}
      </Box>
    </Layout.Sider>
  );
};
